module.exports = __webpack_public_path__ + "img/title.96277737.png";